import styled from 'styled-components';
import { ReactComponent as EmptyStateIcon } from '@elementary/common-ui/assets/24x24/empty-state.svg';
import { FlexColumn } from '@elementary/common-ui/components';
import { Button, Typography } from '@mui/material';
import useNavigateWithEnv from 'shared/hooks/useNavigateWithEnv';

type Variant = 'regular' | 'big' | 'wide';

const Wrapper = styled(FlexColumn)`
  justify-content: center;
  align-items: center;
`;

const Message = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray2};
  font-size: 10px;
`;

type Props = {
  variant?: Variant;
};

const emptyStateMessage = 'There is no data to display';

type ButtonProps = {
  height?: number;
  fontSize?: number;
};

const AddTestButton = ({ height = 24, fontSize = 13 }: ButtonProps) => {
  const navigate = useNavigateWithEnv();
  return (
    <Button
      onClick={() => {
        navigate('/test-management');
      }}
      sx={{
        height,
        fontSize,
        background: 'common.lightBlue4',
        color: 'common.blue7',
        borderRadius: '2px',
      }}
    >
      Add tests
    </Button>
  );
};

const EmptyState = ({ variant = 'regular' }: Props) => {
  if (variant === 'big') {
    return (
      <Wrapper gap="20px">
        <EmptyStateIcon />
        <Typography>Coming soon</Typography>
      </Wrapper>
    );
  }

  if (variant === 'wide') {
    return (
      <Wrapper sx={{ height: '115px' }}>
        <EmptyStateIcon />
        <Message
          sx={{
            marginTop: '8px',
            marginBottom: '8px',
          }}
        >
          {emptyStateMessage}
        </Message>
        <AddTestButton height={17} fontSize={10} />
      </Wrapper>
    );
  }

  return (
    <Wrapper sx={{ height: '156px' }}>
      <EmptyStateIcon />
      <Message
        sx={{
          marginTop: '8px',
          marginBottom: '16px',
        }}
      >
        {emptyStateMessage}
      </Message>
      <AddTestButton />
    </Wrapper>
  );
};

export default EmptyState;
